import EnterpriseBuilderScreenStep from './EnterpriseBuilderScreenStep';
import EnterpriseView from './components/enterprise/EnterpriseView';
import ResourceOverviewGrid from './components/resources/ResourceGrid/ResourceOverviewGrid';
import DashboardView from './components/dashboard/DashboardView';
import { CategoriesView } from './components/categories/CategoriesView';
import { FloorsView } from './components/floors/FloorsView';
import Resources from './components/resources/ResourceEntityManager/Resources';

export default {
    [EnterpriseBuilderScreenStep.Dashboard]: { component: DashboardView, scope: 'dashboard' },
    [EnterpriseBuilderScreenStep.Enterprise]: { component: EnterpriseView, scope: 'enterprise' },
    [EnterpriseBuilderScreenStep.ResourceCategories]: { component: CategoriesView, scope: 'categories' },
    [EnterpriseBuilderScreenStep.Floors]: { component: FloorsView, scope: 'floors' },
    [EnterpriseBuilderScreenStep.ResourceOverviewGrid]: {
        component: ResourceOverviewGrid,
        scope: 'resourceOverviewGrid',
    },
    [EnterpriseBuilderScreenStep.Resources]: { component: Resources, scope: 'resources' },
};
